import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getBookingsAutomationSettingsRequest = {};
var _getBookingsAutomationSettingsResponse = {};
function resolveComWixpressBookingsBoAutomationSettingsBookingsAutomationServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_serverless/bookings-bo-automation-settings-reader',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_serverless/bookings-bo-automation-settings-reader',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_serverless/bookings-bo-automation-settings-reader',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_serverless/bookings-bo-automation-settings-reader',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_serverless/bookings-bo-automation-settings-reader',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/bookings-bo-automation-settings-reader',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/bookings-bo-automation-settings-reader',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/bookings-bo-automation-settings-reader',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/bookings-bo-automation-settings-reader',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/bookings-bo-automation-settings-reader',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Define the RPC method. */
export function getBookingsAutomationSettings(payload) {
    var _a = serializer(_getBookingsAutomationSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBookingsAutomationSettingsResponse, {}).fromJSON;
    function __getBookingsAutomationSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.bookings_automation_settings',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.boAutomationSettings.BookingsAutomationService.GetBookingsAutomationSettings',
            url: resolveComWixpressBookingsBoAutomationSettingsBookingsAutomationServiceUrl({
                protoPath: '/v1/bookings-automation/get-bookings-automation-settings',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBookingsAutomationSettings.fromReq = fromReq;
    __getBookingsAutomationSettings.__isAmbassador = true;
    return __getBookingsAutomationSettings;
}
//# sourceMappingURL=http.impl.js.map